import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import ApiService from './services/api.service'
import { TokenService } from './services/storage.service'
import { VueMorphling } from 'vue-morphling';
// import 'babel-polyfill';
// import "@babel/polyfill";

// var featureDetect = function () {
//   var vueTest = ('__defineSetter__' in Object.prototype);
//   var svgTest = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect;
//   var transitionTest = ('transition' in document.documentElement.style) || ('WebkitTransition' in document.documentElement.style);
//   alert(vueTest + '//' + svgTest + '//' + transitionTest);
//   return vueTest && svgTest && transitionTest;
// }

// if(!featureDetect()) {
//   alert('Sorry, the browser you are using was not support by our browser, please try to use following supported browsers: Chrome, Edge, Firefox, Iphone or Android Phone.')
// }

// Use all filters and directives.
Vue.use(VueMorphling);

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    formatCurrency(price, currnIdx) {
      // return this.$morphCurrency(price, currnIdx === 1009? 'EUR' : '');
      var formatter = (currnIdx === 1009) ?
        new Intl.NumberFormat('en-DE', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
        })
        : new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        });
      return formatter.format(price);
    },
    allUsStates() {
      return [
        {name: "Alabama", abbreviation: "AL"},
        {name: "Alaska", abbreviation: "AK"},
        {name: "American Samoa", abbreviation: "AS"},
        {name: "Arizona", abbreviation: "AZ"},
        {name: "Arkansas", abbreviation: "AR"},
        {name: "California", abbreviation: "CA"},
        {name: "Colorado", abbreviation: "CO"},
        {name: "Connecticut", abbreviation: "CT"},
        {name: "Delaware", abbreviation: "DE"},
        {name: "District Of Columbia", abbreviation: "DC"},
        {name: "Federated States Of Micronesia", abbreviation: "FM"},
        {name: "Florida", abbreviation: "FL"},
        {name: "Georgia", abbreviation: "GA"},
        {name: "Guam", abbreviation: "GU"},
        {name: "Hawaii", abbreviation: "HI"},
        {name: "Idaho", abbreviation: "ID"},
        {name: "Illinois", abbreviation: "IL"},
        {name: "Indiana", abbreviation: "IN"},
        {name: "Iowa", abbreviation: "IA"},
        {name: "Kansas", abbreviation: "KS"},
        {name: "Kentucky", abbreviation: "KY"},
        {name: "Louisiana", abbreviation: "LA"},
        {name: "Maine", abbreviation: "ME"},
        {name: "Marshall Islands", abbreviation: "MH"},
        {name: "Maryland", abbreviation: "MD"},
        {name: "Massachusetts", abbreviation: "MA"},
        {name: "Michigan", abbreviation: "MI"},
        {name: "Minnesota", abbreviation: "MN"},
        {name: "Mississippi", abbreviation: "MS"},
        {name: "Missouri", abbreviation: "MO"},
        {name: "Montana", abbreviation: "MT"},
        {name: "Nebraska", abbreviation: "NE"},
        {name: "Nevada", abbreviation: "NV"},
        {name: "New Hampshire", abbreviation: "NH"},
        {name: "New Jersey", abbreviation: "NJ"},
        {name: "New Mexico", abbreviation: "NM"},
        {name: "New York", abbreviation: "NY"},
        {name: "North Carolina", abbreviation: "NC"},
        {name: "North Dakota", abbreviation: "ND"},
        {name: "Northern Mariana Islands", abbreviation: "MP"},
        {name: "Ohio", abbreviation: "OH"},
        {name: "Oklahoma", abbreviation: "OK"},
        {name: "Oregon", abbreviation: "OR"},
        {name: "Palau", abbreviation: "PW"},
        {name: "Pennsylvania", abbreviation: "PA"},
        {name: "Puerto Rico", abbreviation: "PR"},
        {name: "Rhode Island", abbreviation: "RI"},
        {name: "South Carolina", abbreviation: "SC"},
        {name: "South Dakota", abbreviation: "SD"},
        {name: "Tennessee", abbreviation: "TN"},
        {name: "Texas", abbreviation: "TX"},
        {name: "Utah", abbreviation: "UT"},
        {name: "Vermont", abbreviation: "VT"},
        {name: "Virgin Islands", abbreviation: "VI"},
        {name: "Virginia", abbreviation: "VA"},
        {name: "Washington", abbreviation: "WA"},
        {name: "West Virginia", abbreviation: "WV"},
        {name: "Wisconsin", abbreviation: "WI"},
        {name: "Wyoming", abbreviation: "WY"}
      ]
    },
  }
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
})

new Vue({
  // data () {return {}},
  router,
  store,
  render: h => h(App),
  created () {
    // console.table(process.env)
    // Set the base URL of the API
    ApiService.init(process.env.VUE_APP_ROOT_API)

    ApiService.mount401Interceptor()

    // If token exists set header
    if (TokenService.getToken()) {
      ApiService.setHeader()
    }
  }
}).$mount('#app')
